<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="1" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-row :gutter="10" style="margin: 1rem 0">
          <CommonExcel ref="CommonExcelRef2" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
          <clear-cache-apply />
        </el-row>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%" height="600">
              <el-table-column label="序号" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template v-slot:default="{row}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template v-slot:default="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                  <el-button type="success" size="mini" @click="handleCopy(row)">拷贝</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="提示" :visible.sync="dialog" width="70%">
        <el-table :key="tableKey" size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <template v-if="type==1">
            <el-table-column prop="target" label="等级">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.level" placeholder="等级" />
              </template>
            </el-table-column>
            <el-table-column prop="max" label="max">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.max" placeholder="max" />
              </template>
            </el-table-column>
            <el-table-column prop="isGrandPrize" label="是否是大奖">
              <template v-slot:default="scope">
                <el-select v-model.number="scope.row.isGrandPrize" style="width:150px" placeholder="请选择">
                  <el-option
                    v-for="item in alertStatusType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="prize" label="免费奖励" width="350">
              <template v-slot:default="scope">
                <Reward :value="scope.row.prize" />
              </template>
            </el-table-column>
            <el-table-column prop="specialPrize" label="付费奖励配置" width="350">
              <template v-slot:default="scope">
                <Reward :value="scope.row.specialPrize" />
              </template>
            </el-table-column>
            <el-table-column v-if="type === 'traffic_permit3'" prop="superPrize" label="付费奖励配置2" width="350">
              <template v-slot:default="scope">
                <Reward :value="scope.row.superPrize" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type==2">
            <!--            <el-table-column prop="id" label="类型">-->
            <!--              <template v-slot:default="scope">-->
            <!--                <el-input v-model.number="scope.row.id" />-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column prop="extraData" label="类型">
              <template v-slot:default="scope">
                <el-select v-model.number="scope.row.type" placeholder="请选择" @change="getTaskType">
                  <el-option
                    v-for="item in taskType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="需要完成次数">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.num" />
              </template>
            </el-table-column>
            <el-table-column prop="getNum" label="可获得经验值">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.getNum" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type==3">
            <el-table-column prop="price" align="center" label="类型">
              <Price />
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button size="small" type="primary" @click="addRewardDialogList">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { actAuxiliary, actionActAuxiliary, delActAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import Price from '@/components/Price/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { getTaskTypesList } from '@/api/config/activity-cfg'

export default {
  name: 'TrafficPermit',
  components: { ClearCacheApply, Price, CommonExcel, Reward },
  data() {
    return {
      tableKey: 0,
      taskType: [],
      alertStatusType: [{ label: '关闭', value: 0 }, { label: '开启', value: 1 }],
      loading: false,
      dialog: false,
      diaLogList: [],
      list: [],
      type: 1,
      typeArr: { 1: '奖励配置', 2: '任务配置' },
      curClass: 'traffic_permit'
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getTaskTypes()
      this.getList()
    },
    openDialog(config) {
      this.tableKey++
      if (this.type === 2) {
        this.getTaskType()
      }
      this.diaLogList = config
      this.dialog = true
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    getTaskTypes() {
      getTaskTypesList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.taskType.push({ 'label': res.data[i], 'value': parseInt(i), disabled: false })
            // this.taskType2.push({ 'label': res.data[i], 'value': parseInt(i), disabled: false })
          }
        }
      })
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      this.$confirm('确认要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (id !== 0) {
          delActAuxiliary({ idList: [id] })
        }
        this.list[this.type].splice(index, 1)
      })
    },
    handleCopy(row) {
      const _row = Object.assign({}, row)
      _row.id = 0
      this.list[this.type].push(_row)
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name === sheet) {
            this.list[this.type][j].config = excelData[i].sheetData
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, excelData[i].sheetData)
        }
      }
    },
    handleSaveConfig(type) {
      actionActAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      fileName = this.typeArr[type]
      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef2.makeExcelData(dataArr[i], { stage: '阶段', specialReward: { name: '奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }}, reward: { name: '奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }}})
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addRewardDialogList(index) {
      switch (this.type) {
        case 1:
          this.diaLogList.push({ level: 0, max: 0, isGrandPrize: 1, prize: [], specialPrize: [], superPrize: [] })
          break

        case 2: {
          const taskType = this.getTaskType()
          if (taskType < 1) {
            this.msgError('无可用类型')
            return
          }
          this.diaLogList.push({ type: taskType, num: 1, getNum: 0, curTaskNum: 0, curSpendSpins: 0 })
          break
        }
        case 3:
          break
      }
    },
    getTaskType() {
      const taskListType = []
      const taskType = []
      this.diaLogList.forEach(item => {
        taskListType.push(item.type)
      })
      for (const i in this.taskType) {
        const val = this.taskType[i]
        this.taskType[i].disabled = false
        if (taskListType.includes(val.value)) {
          this.taskType[i].disabled = true
        } else {
          taskType.push(val.value)
        }
      }
      if (taskType.length > 0) {
        return taskType[0]
      }
      return 0
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
      if (this.type) {
        this.getTaskType()
      }
    }
  }
}
</script>

